import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubscriptIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subscript"}/>
}
